export default {
  functionKey: "DROITE",
  title: "DROITE",
  group: "Texte",
  origin: [],
  target: [],
  arguments: [],
  maxArguments: 1,
  requiredArguments: [
    { argumentKey: "Length", name: "Nombre de caractères" }
  ],
  expectedArguments: [
    { name: "Nombre de caractères", argumentKey: "Length", single: true, initialValue: "1" }
  ],
  description: "Retourne les N derniers caractères. (Ex: DROITE('helloworld', 3) -> 'rld')",
  isStarred: false,

  generate(destination, origin, args, isArgumentCol) {
    const length = args[0] ?? "1";
    const code = `${destination} = ${origin}.slice(-${length});`;
    return { displayCode: code, safeCode: code };
  }
}
